<template>
    <div>
        <Logo></Logo>
        <div class="container-fluid bg-3 text-center">
            <div class="block_container drop">
                <div v-for="index in 220" :key="index" :class="`block block_${index}`"></div>
                <div class="clearfix"></div>
            </div>
        </div>
        <!-----------------contents-------------->
        <div class="main">

            <!-------------------------------contact-------------------------------------------->
            <div class="animated_modal_contents contact_contents none">
                <div class="colorPages">
                    <div class="col-md-12">
                        <div class="form-area">
                            <form role="form" action="#" method="POST" @submit="contactSubmit" class="contactForm">
                                <div class="alert alert-info" v-if="message">{{message}}</div>
                                <div class="form-group">
                                    <input type="text" class="form-control" id="name" v-model="contact.name" placeholder="Name" required autocomplete="off">
                                </div>
                                <div class="form-group">
                                    <input type="email" class="form-control" id="email" v-model="contact.email" placeholder="Email" required autocomplete="off">
                                </div>
                                <div class="form-group">
                                    <input type="text" class="form-control" id="mobile" v-model="contact.mobile" placeholder="Mobile Number" required autocomplete="off">
                                </div>
                                <div class="form-group">
                                    <input type="text" class="form-control" id="subject" v-model="contact.subject" placeholder="Subject" required autocomplete="off">
                                </div>
                                <div class="form-group">
                                    <textarea class="form-control" type="textarea" id="message" v-model="contact.message" placeholder="Message" maxlength="140" rows="3" required autocomplete="off"></textarea>
                                    <!--    <span class="help-block">
                                            <p id="characterLeft" class="help-block ">You have reached the limit</p>
                                        </span>-->
                                </div>

                                <button type="submit" class="btn btn-primary pull-right">Submit</button>
                            </form>
                        </div>

                    </div>
                </div>
            </div>

            <div id="demo" data-animation="hierarchical-display" data-animation-in="tada" data-animationOut="zoomOut" data-speed="3">
                <a :href="`${baseUrl}`" id="close" data-value="hide"></a>
                <div id="mainTitle"></div>
                <div v-for="x in 62" :key="x" :id="`x${x}`"></div>
            </div>

        </div>
        <!--------------end main 3---------------->
        <input class="blockWidth" type="hidden" value="95">
    </div>
</template>

<script>
  import Logo from './Logo.vue';
  export default {
    components: {
      Logo,
    },
    data() {
      return {
        blockWidth: 95,
        blockHeight: 95,
        contact: {},
        message: false,
      };
    },
    mounted() {
      const that = this;
      window.addEventListener(`resize`, function () {
        const width = $(window)
          .width();
        that.resize_block(width, this.blockWidth);
        if (width > 800) {
          location.reload();
        }
      });

      let effect = 'zoomInUp';
      $('#demo').children().addClass(effect + ' animated');
      let screen_width = '';
      screen_width = $(window).width();
      $(".main").css("left", '0px');

      $('#demo').hierarchicalDisplay({
          speed: 6,
        });
      setTimeout(function () {
        $("#demo").css("background", '#ffffff');
        $('.contact_contents').fadeIn();
        $('#animationOut').after('<i class="fa fa-times fake_close" aria-hidden="true"></i>');
      }, 1500);
    },
    methods: {
      contactSubmit: function (e) {
        e.preventDefault();
        this.$http.post(`contactQuery`, this.contact)
          .then((response) => {
            this.message = response.data;
            this.contact = {};
          })
          .catch((error) => {
            if (error.response.status) {
              this.message = `Please try again later.`;
            }
          });
      },
      set_html(array, total, menuStart) {
        for (var i = 0; i < total; i++) {
          const menuNo = i + menuStart;
          const html = $('.menu' + menuNo)
            .html();
          $('.block_' + array[i])
            .html(html);
        }
      },
      resize_block(width, blockWidth) {
        let screenWidth = 0;
        let blockCount = 0;
        let newBlockSize = 0;
        screenWidth = width - 10;
        blockCount = screenWidth / blockWidth;
        blockCount = Math.round(blockCount);
        newBlockSize = screenWidth / blockCount;
        newBlockSize = newBlockSize - .25;
        $('.block')
          .css({ 'width': newBlockSize });
        this.blockWidth = newBlockSize;
        $(".blockWidth")
          .val(newBlockSize);

        let height = $(window)
          .height();
        if (height >= 1025) {
          $('.block_container')
            .css({ 'height': height + 'px' });
        }
      },
    },
  };
</script>
